import { useMemo } from "react"

import * as turf from "@turf/turf"

import { useGeoServerFeaturesList, useReverseGeocoding } from "@l2r-front/l2r-geodata"
import { useTranslation } from "@l2r-front/l2r-i18n"
import { Typography } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../constants/i18n"
import { useNetworksStateContext } from "../../contexts/NetworksContext"
import { networksQueryKeys } from "../../hooks"

import * as Styled from "./RoadDetailCity.styled"

export const RoadDetailCity = (props) => {

    const { road } = props

    const { t } = useTranslation(I18N_NAMESPACE)
    const { selectedNetwork } = useNetworksStateContext()

    const queryParams = {
        layer: selectedNetwork.referential.layerSection,
        linear_location_road: road,
    }
    const { data: roadSegments, isLoading, isError } = useGeoServerFeaturesList(
        networksQueryKeys.list(queryParams),
        queryParams,
        {
            enabled: !!road && !!selectedNetwork.referential.layerSection,
        })

    const segmentCenter = useMemo(() => {
        if (!roadSegments?.length) {
            return null
        }

        const segment = roadSegments[0]
        if (segment?.geometry) {
            return turf.center(segment.geometry).geometry.coordinates
        } else {
            return null
        }
    }, [roadSegments])

    const { data: geocodingData, isLoading: isLoadingGeocoding, isError: isErrorGeocoding } = useReverseGeocoding(
        segmentCenter ? segmentCenter[1] : null,
        segmentCenter ? segmentCenter[0] : null,
        12,
        {
            enabled: !!segmentCenter,
        })

    const segmentCity = useMemo(() => {
        if (!geocodingData) {
            return null
        }
        return geocodingData?.address?.city ?? geocodingData?.address?.town ?? geocodingData?.address?.village
    }, [geocodingData])

    if (isError || isErrorGeocoding) {
        return <Styled.ErrorText variant="Regular">{t(I18N_NAMESPACE, "containers.segmentDetailCity.error")}</Styled.ErrorText>
    }

    if (isLoading || isLoadingGeocoding) {
        return <Styled.Skeleton />
    }

    return (
        <Typography id="road-detail-city" variant="Regular">{segmentCity}</Typography>
    )
}